import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
  
})
export class AppComponent implements OnInit {
  items: any[] = [];
  
  constructor(private primengConfig: PrimeNGConfig, private router: Router) {
    
   }

  ngOnInit() {
      this.primengConfig.ripple = true;
  }
  
}